import {useResourcesToken} from '@/di/di.root-container.hooks';

import cn from 'classnames';

import s from './ErrorTimestamp.module.css';

export interface ErrorTimestampProps {
  timestamp?: string;
  className?: string;
}

export const ErrorTimestamp = ({timestamp, className}: ErrorTimestampProps): JSX.Element => {
  const {
    content: {
      ErrorCodeMessage: {timestampText},
    },
  } = useResourcesToken();

  const getErrorTimestamp = (): string => {
    if (timestamp) {
      return timestamp;
    }

    return new Date().toISOString();
  };

  return (
    <span className={cn(s.timestamp, className)}>
      {timestampText}
      {getErrorTimestamp()}
    </span>
  );
};
